export const exportRecordsZh = {
  header: {
    title: '导出记录',
    desc: '查看和管理数据导出任务，下载已完成的导出文件',
  },
  statCards: {
    total: '总导出数',
    completed: '已完成',
    processing: '处理中',
    pending: '待导出',
  },
  actions: {
    search: '搜索',
    reset: '重置',
    download: '下载',
    prevPage: '上一页',
    nextPage: '下一页',
  },
  table: {
    headers: {
      serialNo: '序号',
      fileName: '文件名',
      exportTime: '导出时间',
      recordCount: '记录数',
      fileSize: '文件大小',
      status: '状态',
      action: '操作',
    },
  },
  defaultFileName: '短信记录',
}

export const exportRecordsEn = {
  header: {
    title: 'Export Records',
    desc: 'View and manage data export tasks, and download completed export files',
  },
  statCards: {
    total: 'Total Exports',
    completed: 'Completed',
    processing: 'Processing',
    pending: 'Pending',
  },
  actions: {
    search: 'Search',
    reset: 'Reset',
    download: 'Download',
    prevPage: 'Previous',
    nextPage: 'Next',
  },
  table: {
    headers: {
      serialNo: 'No.',
      fileName: 'File Name',
      exportTime: 'Exported',
      recordCount: 'Records',
      fileSize: 'Size',
      status: 'Status',
      action: 'Action',
    },
  },
  defaultFileName: 'SMS Records',
}

export const exportRecordsJa = {
  header: {
    title: 'エクスポート履歴',
    desc: 'データエクスポートタスクの確認・管理、完了したファイルのダウンロード',
  },
  statCards: {
    total: '総エクスポート数',
    completed: '完了',
    processing: '処理中',
    pending: '待機中',
  },
  actions: {
    search: '検索',
    reset: 'リセット',
    download: 'ダウンロード',
    prevPage: '前へ',
    nextPage: '次へ',
  },
  table: {
    headers: {
      serialNo: '番号',
      fileName: 'ファイル名',
      exportTime: 'エクスポート日時',
      recordCount: '件数',
      fileSize: 'サイズ',
      status: 'ステータス',
      action: '操作',
    },
  },
  defaultFileName: 'SMS記録',
}
